import React from 'react'

const ClockDetailed = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35754 3.50158C7.18473 3.41105 5.97861 3.75222 5.0191 4.54738C3.80828 5.55081 3.27498 7.03996 3.46096 8.47114C3.6105 9.62184 5.00195 9.81854 5.89545 9.07816L9.40065 6.17366C10.334 5.40024 10.343 3.93412 9.16835 3.635C8.90225 3.56724 8.6308 3.52267 8.35754 3.50158ZM28.398 5.79683C29.1932 6.75634 29.5343 7.96246 29.4438 9.13527C29.4227 9.40853 29.3782 9.67999 29.3104 9.94609C29.0113 11.1208 27.5452 11.1118 26.7717 10.1784L23.8672 6.67318C23.1269 5.77968 23.3236 4.38823 24.4743 4.23869C25.9054 4.05271 27.3946 4.58601 28.398 5.79683ZM26 18C26 22.4183 22.4183 26 18 26C13.5817 26 10 22.4183 10 18C10 13.5817 13.5817 10 18 10C22.4183 10 26 13.5817 26 18Z"
        fill="#FEC077"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5626 2.5C14.5626 1.67157 15.2341 1 16.0626 1C16.891 1 17.5626 1.67157 17.5626 2.5C17.5626 3.32843 16.891 4 16.0626 4C15.2341 4 14.5626 3.32843 14.5626 2.5ZM16.0626 2C15.7864 2 15.5626 2.22386 15.5626 2.5C15.5626 2.77614 15.7864 3 16.0626 3C16.3387 3 16.5626 2.77614 16.5626 2.5C16.5626 2.22386 16.3387 2 16.0626 2Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        d="M16.0626 12C16.3387 12 16.5626 12.2239 16.5626 12.5V17H20.0626C20.3387 17 20.5626 17.2239 20.5626 17.5C20.5626 17.7761 20.3387 18 20.0626 18H16.0626C15.7864 18 15.5626 17.7761 15.5626 17.5V12.5C15.5626 12.2239 15.7864 12 16.0626 12Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5626 17.5C26.5626 11.701 21.8615 7 16.0626 7C10.2636 7 5.56255 11.701 5.56255 17.5C5.56255 23.299 10.2636 28 16.0626 28C21.8615 28 26.5626 23.299 26.5626 17.5ZM16.5626 9.5V8.01293C21.4113 8.26435 25.2982 12.1513 25.5496 17H24.0626C23.7864 17 23.5626 17.2239 23.5626 17.5C23.5626 17.7761 23.7864 18 24.0626 18H25.5496C25.2971 22.8695 21.3779 26.7689 16.5002 26.9901V25C16.5002 24.7239 16.2763 24.5 16.0002 24.5C15.7241 24.5 15.5002 24.7239 15.5002 25V26.9836C10.6806 26.7023 6.82583 22.8279 6.57549 18H8.06255C8.3387 18 8.56255 17.7761 8.56255 17.5C8.56255 17.2239 8.3387 17 8.06255 17H6.57549C6.82691 12.1513 10.7139 8.26435 15.5626 8.01293V9.5C15.5626 9.77614 15.7864 10 16.0626 10C16.3387 10 16.5626 9.77614 16.5626 9.5Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0626 5C9.15899 5 3.56255 10.5964 3.56255 17.5C3.56255 24.4036 9.15899 30 16.0626 30C22.9661 30 28.5626 24.4036 28.5626 17.5C28.5626 10.5964 22.9661 5 16.0626 5ZM4.56255 17.5C4.56255 11.1487 9.71128 6 16.0626 6C22.4138 6 27.5626 11.1487 27.5626 17.5C27.5626 23.8513 22.4138 29 16.0626 29C9.71128 29 4.56255 23.8513 4.56255 17.5Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        d="M25.3626 27.1C25.1416 26.9343 24.8282 26.9791 24.6626 27.2C24.4969 27.4209 24.5416 27.7343 24.7626 27.9L28.7626 30.9C28.9835 31.0657 29.2969 31.0209 29.4626 30.8C29.6282 30.5791 29.5835 30.2657 29.3626 30.1L25.3626 27.1Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        d="M7.46255 27.2C7.62824 27.4209 7.58347 27.7343 7.36255 27.9L3.36255 30.9C3.14164 31.0657 2.82824 31.0209 2.66255 30.8C2.49687 30.5791 2.54164 30.2657 2.76255 30.1L6.76255 27.1C6.98347 26.9343 7.29687 26.9791 7.46255 27.2Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        d="M3.34298 10.636C2.70161 10.032 2.50568 9.2178 2.6933 8.28458C2.88401 7.33595 3.47204 6.29019 4.36421 5.3428C6.14782 3.44877 8.36436 3.14637 9.65741 4.36404C9.85845 4.55336 10.1749 4.54386 10.3642 4.34282C10.5535 4.14179 10.544 3.82535 10.343 3.63603C8.46475 1.8673 5.59914 2.57277 3.6362 4.65723C2.65508 5.69908 1.95029 6.90673 1.71291 8.08749C1.47243 9.28366 1.71315 10.4748 2.65741 11.364C2.85845 11.5533 3.17489 11.5438 3.3642 11.3428C3.55352 11.1418 3.54402 10.8253 3.34298 10.636Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
      <path
        d="M28.6574 10.636C29.2988 10.032 29.4947 9.2178 29.3071 8.28458C29.1164 7.33595 28.5284 6.29019 27.6362 5.3428C25.8526 3.44877 23.636 3.14637 22.343 4.36404C22.142 4.55336 21.8255 4.54386 21.6362 4.34282C21.4469 4.14179 21.4564 3.82535 21.6574 3.63603C23.5356 1.8673 26.4013 2.57277 28.3642 4.65723C29.3453 5.69908 30.0501 6.90673 30.2875 8.08749C30.528 9.28366 30.2873 10.4748 29.343 11.364C29.1419 11.5533 28.8255 11.5438 28.6362 11.3428C28.4469 11.1418 28.4564 10.8253 28.6574 10.636Z"
        // fill="#1D1D1D"
        fill="currentColor"
      />
    </svg>
  )
}

export default ClockDetailed
